import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { actions } from "../../../reducers/cadastro/mapasMensais.actions";
import { getMapasMensais } from "../../../selectors/cadastro/mapasMensais.selectors";
import MapaMensalPage from "./MapaMensalPage";
import {
  actions as routeActions,
  types as routes,
} from "../../../reducers/rotas.actions";
import { getPayload } from "../../../selectors/routes.selectors";

const MapaMensalPageConnected = () => {
  const { loading, data, filter, nomeCliente } = useSelector(getMapasMensais);
  const cliente = useSelector(getPayload);

  const dispatch = useDispatch();

  const handlePagination = (e, page) => {
    dispatch(
      actions.obterMapasMensais.request({
        pagina: page,
        url: filter,
        idCliente: cliente?.id,
      })
    );
  };

  const handleDelete = (e, id) => {
    dispatch(actions.deletarMapaMensal.request({ id }));
  };

  const handleActivate = (e, id) => {
    dispatch(actions.reativarMapaMensal.request({ id, situacao: "A" }));
  };

  const handleEdit = (e, id) => {
    dispatch(
      routeActions.redirectTo(routes.EDITAR_MAPA_MENSAL, {
        id: id,
      })
    );
  };

  const handleAdd = () => {
    dispatch(routeActions.redirectTo(routes.CRIAR_MAPA_MENSAL));
  };

  const handleGoBack = () => {
    dispatch(routeActions.redirectTo(routes.CADASTRO_CLIENTE));
  };

  return (
    <MapaMensalPage
      data={data}
      loading={loading}
      handlePagination={handlePagination}
      handleAdd={handleAdd}
      handleDelete={handleDelete}
      handleEdit={handleEdit}
      handleGoBack={handleGoBack}
      handleActivate={handleActivate}
      filtroAtual={filter}
      nomeCliente={nomeCliente}
      cliente={cliente}
    />
  );
};

export default MapaMensalPageConnected;
